<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Change title</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || !canSave"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <Input v-model="title" size="xl" label="Title" :disabled="loading" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, Input, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeTitle } from './useChangeTitle'

const { close } = useSheet()

const props = defineProps<{
  user: User
}>()

const { title, loading, canSave, save } = useChangeTitle(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
